import { render, staticRenderFns } from "./FaturamentoExecutivo.vue?vue&type=template&id=6f3f702a"
import script from "./FaturamentoExecutivo.vue?vue&type=script&lang=js"
export * from "./FaturamentoExecutivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports